import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ResultOfOperation } from 'app/shared/model/result-of-operation.model';
import { AdminService } from '../admin.service';
import { UserMessagesComponent } from 'app/shared/user-messages/user-messages.component';
import { UserMessagesService } from 'app/shared/user-messages/user-messages.service';
import { MatMenu, MatMenuTrigger } from '@angular/material';

@Component({
  selector: 'app-admin-activities',
  templateUrl: './admin-activities.component.html',
  styleUrls: ['./admin-activities.component.css']
})
export class AdminActivitiesComponent implements OnInit {

  @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;

  constructor(private router:Router, private _adminService: AdminService) { }

  ngOnInit() {}

  navigate(url: string): void
  {
    this.router.navigateByUrl(url);
  }
}
